import React from "react";
import { createUseStyles } from "react-jss";
import PropTypes from "prop-types";
import {
  cardStyles,
  modalGenericStyles,
  variables,
} from "../../../../../../variables";
import { toast } from "react-toastify";
import GenericBasicInfo from "../../../../../../components/cards/GenericBasicInfo";
import _ from "lodash";
import { genericRequestErrorHandler } from "../../../../../../api";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import {} from "../../../../../../api/Vendor/Transfer";
import { deleteFERVendor } from "../../../../../../api/Vendor/Ferries";
import Loader from "../../../../../../components/Loader";
import { CustomButton } from "../../../../../../components/CustomButton";

const statusOptions = {
  "": "-----",
  AC: "Active",
  IN: "Inactive",
  CA: "Candidate",
};

const styles = createUseStyles({
  ...modalGenericStyles,
  DeleteFerryVendorModal: modalGenericStyles.modal,
  modalCard: {
    ...modalGenericStyles.card,
    gridTemplateRows: "max-content  1fr max-content",
  },
  modalCardHeader: {
    ...modalGenericStyles.cardHeader,
  },
  modalCardBody: {
    ...modalGenericStyles.cardBody,
    display: "grid",
  },
  modalCardActions: {
    ...modalGenericStyles.cardActions,
  },
  card: cardStyles.card,
  cardHeader: cardStyles.header,
  cardBody: {
    ...cardStyles.body,
    gap: variables.normal_gap,
  },
});

const DeleteFerryVendorModal = ({ deletedId, data, onClose }) => {
  const classes = styles();
  const queryClient = useQueryClient();

  const basicDataCpl = [
    ["Id", "id"],
    ["Vendor", null, _.get(data, "vendor", "").split("fer__")[1] || "N/A"],
    ["Market_type", "market_type"],
    ["Member", "member"],
    ["Notes", "notes"],
    [
      "Payment Validation",
      null,
      _.get(data, "payment_validation") === true ? "Yes" : "No" || "N/A",
    ],
    ["CXL Strategy Time", "cxl_strategy_time"],
    [
      "CXL Strategy Daysahead",
      null,
      _.get(data, "cxl_strategy_daysahead", []) === 0
        ? "0"
        : _.get(data, "cxl_strategy_daysahead"),
    ],
    ["Status", null, _.get(statusOptions, _.get(data, "status", "") || "N/A")],
  ];

  const DeleteTransferVendorMutation = useMutation(deleteFERVendor, {
    onSuccess: () => {
      toast.success("Ferry Vendor Deleted");
      queryClient.invalidateQueries("VendorsFER");
      onClose();
    },
    onError: (error) => genericRequestErrorHandler(error),
  });
  const onDelete = async (id) => {
    await DeleteTransferVendorMutation.mutateAsync({ id });
  };

  return (
    <div className={classes.DeleteFerryVendorModal}>
      <React.Fragment>
        <div id="DeleteFERVendorModal" className={classes.modalCard}>
          {DeleteTransferVendorMutation.isLoading && <Loader onTop={true} />}
          <div className={classes.modalCardHeader}>
            <span>DELETE Ferry Vendor</span>
          </div>
          <div className={classes.modalCardBody}>
            <div className={classes.cardBody}>
              <GenericBasicInfo
                header={"Basic Data"}
                cardInfo={basicDataCpl}
                objectData={data}
              />
            </div>
          </div>
          <div className={classes.modalCardActions}>
            <CustomButton
              id="DeleteFERVendorModalCloseButton"
              appearance="ghost"
              onClick={onClose}>
              <strong>Cancel</strong>
            </CustomButton>
            <CustomButton
              id="DeleteFERModalConfirmButton"
              appearance="primary"
              onClick={() => {
                onDelete(deletedId);
              }}>
              <strong>DELETE</strong>
            </CustomButton>
          </div>
        </div>
      </React.Fragment>
    </div>
  );
};
DeleteFerryVendorModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  data: PropTypes.object.isRequired,
  deletedId: PropTypes.string.isRequired,
};
export default DeleteFerryVendorModal;
